/* eslint-disable */
import { useMemo } from 'react';

import { skipToken } from '@reduxjs/toolkit/query';

import { useGetAvailableStatusTransitionsQuery, useGetPoliciesQuery } from '../store/policiesSlice';
import { PolicyWithTerminationInfo } from '../models/policy';
import { useAppSelector } from '../store/store';

/**
 * Custom hook that retrieves the customer's policies together with their available status transitions.
 */
export function useGetPoliciesWithAvailableStatusTransitionsQuery() {
  const isLoggedIn = useAppSelector(state => state.auth.isUserLogged);
  const { data: policies, isLoading } = useGetPoliciesQuery(undefined, { skip: !isLoggedIn });
  // Subsequent queries to fire only after the first has retrieved its data
  const { data: statusTransitions1, isLoading: isLoading1 } = useGetAvailableStatusTransitionsQuery((policies && policies[0]?.uniqueIdentifier) ?? skipToken);
  const { data: statusTransitions2, isLoading: isLoading2 } = useGetAvailableStatusTransitionsQuery((policies && policies[1]?.uniqueIdentifier) ?? skipToken);

  // Most important to use `useMemo` to ensure that React does not re-render
  const policiesWithAvailableStatusTransitions: PolicyWithTerminationInfo[] | undefined = useMemo(() => {
    let policiesWithTerminationInfo: PolicyWithTerminationInfo[] = [];
    if (policies) {
      if (statusTransitions1) policiesWithTerminationInfo.push(new PolicyWithTerminationInfo(policies[0], statusTransitions1));
      if (statusTransitions2) policiesWithTerminationInfo.push(new PolicyWithTerminationInfo(policies[1], statusTransitions2));
    }
    return policiesWithTerminationInfo;
  }, [statusTransitions1, statusTransitions2]);

  return {
    data: policiesWithAvailableStatusTransitions,
    isLoading: isLoading || isLoading1 || isLoading2
  };
}